__webpack_require__.p = "https://static.studykik.com/prd-v2/corporate-web/";